import { DatabaseInstance } from "./databaseClass";

class LeaderboardClass {
  constructor() {}

  public leaderboardBetweenDates = async ({
    startDate,
    endDate,
    isUCA,
  }: {
    startDate: string;
    endDate: string;
    isUCA: boolean;
  }) => {
    const data = {
      data: {
        startDatePST: startDate,
        endDatePST: endDate,
        isUCA,
      },
      endpoint: "admin/leaderboard-between-dates",
    };

    const res = await DatabaseInstance.createRecord(data);

    return res;
  };
}

const LeaderboardInstance = new LeaderboardClass();

export { LeaderboardInstance };
